//
// Module for the Participant Communication's Document Detail view
//
rs.module("content/participant/account/communications/documentdetail",

    ["common/select-helper" ],

    function (selectHelper) {

        // Global mapping of the edm name to its destination.
        var _destinationDictionary = {};

        // Initialize the module
        function initialize(jsSelectors, backendUrls, destinationDictionary) {

            // Set dictionary object
            _destinationDictionary = destinationDictionary;

            // Unpack Js Selectors
            var form = $.js(jsSelectors.form);

            var followUpCheckbox = form.js(jsSelectors.followUpCheckbox);
            var assignedToSelect = form.js(jsSelectors.assignedToSelect);
            var documentTypeSelect = form.js(jsSelectors.documentTypeSelect);
            var documentNameSelect = form.js(jsSelectors.documentNameSelect);
            var documentDestinationSelect = form.js(jsSelectors.documentDestinationSelect);
            var documentDestinationHiddenField = form.js(jsSelectors.documentDestinationHiddenField);

            // Get select helper(s)
            var assignedToSelectHelper = selectHelper.getHelper(assignedToSelect);
            var documentNameSelectHelper = selectHelper.getHelper(documentNameSelect);
            var documentDestinationSelectHelper = selectHelper.getHelper(documentDestinationSelect);

            // Unselect the assigned user when the follow up checkbox is unselected.
            followUpCheckbox.change(function () {
                if (!($(this).is(':checked'))) {
                    assignedToSelectHelper.setValue("");
                }
            });

            // Update the follow up checkbox based on selection
            assignedToSelect.change(function () {
                followUpCheckbox.setChecked(assignedToSelect.val() != '');
            });

            // Handle the document type change event
            documentTypeSelect.change(function () {

                // Repopulate Document Name select
                if (documentTypeSelect.val() != '') {

                    $.getJSON(backendUrls.loadDocumentNameOptions,
                        { edmDocumentType: documentTypeSelect.val() })
                        .done(function (data) {

                            // Replace document names drop down.
                            documentNameSelectHelper.replaceOptions(data.namesSelectData, { withBlank: true });

                            // Update mapping
                            _destinationDictionary = data.destinationMapping;
                        });

                    documentNameSelectHelper.setDisabled(false);
                }
                else {

                    // clear any existing items
                    documentNameSelectHelper.setValue("");
                    documentNameSelectHelper.setDisabled(true);
                }

                // Clear destination drop down
                documentNameSelect.clearErrors();
                setDestinationField("");
            });

            // Handle the document name change event
            documentNameSelect.change(function () {

                // Set destination and document action
                if (documentNameSelect.val() != '') {
                    var destinationKey = _destinationDictionary[documentNameSelect.val()];
                    setDestinationField(destinationKey);
                    documentNameSelect.clearErrors();
                }
                else {
                    setDestinationField("");
                }
            });

            // Set the destination select and hidden field to the provided value
            function setDestinationField(value) {
                documentDestinationSelectHelper.setValue(value);
                documentDestinationHiddenField.val(value);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);